import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';

import {PopoverModule} from 'ngx-bootstrap/popover';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';

import { InputTextModule } from 'primeng/inputtext';
import {DataViewModule} from 'primeng/dataview';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { DividerModule } from 'primeng/divider';
import {SkeletonModule} from 'primeng/skeleton';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ButtonModule} from 'primeng/button';
import {PaginatorModule} from 'primeng/paginator';
import {SpinnerModule} from 'primeng/spinner';
import {PanelModule} from 'primeng/panel';
import {DialogModule} from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import {DropdownModule} from 'primeng/dropdown';
import { ChipModule } from 'primeng/chip';
import {TableModule} from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { CalendarModule } from 'primeng/calendar';

import {ShopSystemModule} from '@app/shared/common/shop-system/shop-system.module';
import {UblCommonModule} from '@app/shared/common/shop-system/common/common.module';
import {AppCommonModule} from '@app/shared/common/app-common.module';

import {AxillaCommonModule} from '@axilla/axilla-shared';
import {OnlineHelperModule} from '@axilla/axilla-online-helper';

import {WebshopUtilsModule} from '@shared/utils/utils.module';

import {FieldAgentMappingRoutes} from '@app/webshop/field-agent/field-agent-routing.module';


import {FieldAgentDashboardComponent} from '@app/webshop/field-agent/field-agent-dashboard.component';
import {SelectCustomerComponent} from '@app/webshop/field-agent/select-customer.component';
import {FullNamePipe} from '@app/webshop/field-agent/shared/utils/full-name.pipe';
import {
    ViewAllManagersModalComponent
} from '@app/webshop/field-agent/modals/managers/view-all-managers-modal.component';
import {AddManagerModalComponent} from '@app/webshop/field-agent/modals/managers/add-manager-modal.component';
import {EditCustomerModalComponent} from '@app/webshop/field-agent/modals/customer/edit-customer-modal.component';
import {OrderStateComponent} from '@app/webshop/field-agent/shared/common/order-state/order-state.component';
import {FieldAgentOrderConfirmationComponent} from '@app/webshop/field-agent/field-agent-order-confirmation.component';
import {SignaturePadComponent} from '@app/webshop/field-agent/shared/common/signature/signature-pad.component';
import {ClockComponent} from '@app/webshop/field-agent/shared/common/clock/clock.component';
import {
    ChangeNotificationEmailModalComponent
} from '@app/webshop/field-agent/modals/order-confirmation/change-notification-email-modal.component';
import {FieldAgentOrderSubmittedComponent} from '@app/webshop/field-agent/field-agent-order-submitted.component';
import {
    ProductSelectorModalComponent
} from '@app/webshop/field-agent/shared/common/product-selector/product-selector-modal.component';
import {FieldAgentPromotionsComponent} from '@app/webshop/field-agent/promotions/field-agent-promotions.component';
import {WebshopModule} from '@app/webshop/webshop.module';
import {
    EditLocalWarehouseModalComponent
} from '@app/webshop/field-agent/modals/local-warehouse/edit-local-warehouse-modal.component';
import {AdminModule} from '@app/admin/admin.module';
import {
    ManageLocalWarehouseItemsComponent
} from '@app/webshop/field-agent/modals/local-warehouse/manage-local-warehouse-items.component';
import {AdminLightModule} from '@app/admin/admin-light.module';
import {OrganizationUnitsTreeComponent} from '@app/admin/shared/organization-unit-tree.component';

@NgModule({

    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule.forChild(FieldAgentMappingRoutes),
        ModalModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),

        SkeletonModule,
        TableModule,
        WebshopUtilsModule,
        DropdownModule,
        CalendarModule,
        ButtonModule,
        PaginatorModule,
        AutoCompleteModule,
        TagModule,
        SpinnerModule,
        AxillaCommonModule,
        ShopSystemModule,
        UblCommonModule,
        AppCommonModule,
        ProgressSpinnerModule,
        DataViewModule,
        PanelModule,
        DialogModule,
        InputTextModule,
        HttpClientModule,
        DividerModule,
        ChipModule,
        RadioButtonModule,

        OnlineHelperModule,
        WebshopModule,

        AdminLightModule
    ],
    declarations: [
        SelectCustomerComponent,
        FieldAgentDashboardComponent,
        FieldAgentOrderConfirmationComponent,
        FieldAgentOrderSubmittedComponent,
        ManageLocalWarehouseItemsComponent,

        ViewAllManagersModalComponent,
        AddManagerModalComponent,
        EditCustomerModalComponent,
        ChangeNotificationEmailModalComponent,
        ProductSelectorModalComponent,
        FieldAgentPromotionsComponent,
        EditLocalWarehouseModalComponent,

        OrderStateComponent,
        SignaturePadComponent,
        ClockComponent,

        FullNamePipe
    ],
    exports: [
        FullNamePipe,

        ProductSelectorModalComponent,
        EditLocalWarehouseModalComponent,
        SignaturePadComponent,
        OrderStateComponent,
        ClockComponent
    ],
    providers: [
        BsModalRef,
    ],

})
export class FieldAgentModule {
}
